var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3693_2455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 3.66699C7.78384 3.27633 6.77784 2.66699 5.83317 2.66699C4.43317 2.66699 3.1665 3.49833 3.1665 6.00033C3.1665 9.26633 3.8705 11.607 4.94717 13.025C5.32917 13.529 6.2605 13.3723 6.6585 12.8677C6.92384 12.531 7.2045 11.9083 7.49984 11.0003C7.6945 10.4863 8.0945 9.99766 8.49984 10.0003C8.90117 10.0003 9.3065 10.4917 9.49984 11.0003C9.79517 11.9083 10.0758 12.5303 10.3412 12.867C10.7392 13.373 11.6745 13.529 12.0525 13.025C13.1292 11.607 13.8332 9.26699 13.8332 6.00033C13.8332 3.50699 12.5612 2.66699 11.1665 2.66699C10.2178 2.66699 9.21984 3.27433 8.49984 3.66699Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.66699L10.5 4.66699",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3693_2455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth);
export default __webpack_public_path__ + "static/media/tooth.bb0e2140857aecd380d435a59b850bad.svg";
export { ForwardRef as ReactComponent };